import { useState } from 'react';
import { HubConnectionState } from '@microsoft/signalr';

import { sendSignalRMessage } from '@/lib/signalr';
import { DisplayConnection, Playlist } from '../types';
import { SignalRContext } from '@/providers/app';
import storage from '../utils/storage';

export function useDisplayConnection() {
  const [displayConnection, setDisplayConnection] = useState<DisplayConnection | null>(null);
  const [playlist, setPlaylist] = useState<Playlist | null>(null);

  SignalRContext.useSignalREffect(
    'onDisplayConnect',
    (activeDisplayConnection: DisplayConnection) => {
      setDisplayConnection(activeDisplayConnection);
      void sendSignalRMessage(
        SignalRContext.connection,
        'GetActivePlaylist failed',
        'GetActivePlaylist',
        activeDisplayConnection.displayId
      );
    },
    [displayConnection, playlist]
  );

  SignalRContext.useSignalREffect(
    'onNewDisplay',
    (activeDisplayConnection: DisplayConnection) => {
      console.info('onNewDisplay', activeDisplayConnection);
      setDisplayConnection(activeDisplayConnection);
    },
    [displayConnection, playlist]
  );

  SignalRContext.useSignalREffect(
    'onGetActivePlaylist',
    (activePlaylist: any) => {
      console.info('onGetActivePlaylist', activePlaylist);
      setPlaylist(activePlaylist);
    },
    [displayConnection, playlist]
  );

  SignalRContext.useSignalREffect(
    'onRefreshDisplay',
    () => {
      console.info('onRefreshDisplay');
      window.location.reload();
    },
    [displayConnection, playlist]
  );

  SignalRContext.useSignalREffect(
    'forceDisconnect',
    (action: string) => {
      if (action === 'reload') {
        storage.setDeviceId('');
        window.location.reload();
      }
    },
    [displayConnection, playlist]
  );

  SignalRContext.useSignalREffect(
    'SetActivePlaylist',
    (displayId: string) => {
      void sendSignalRMessage(SignalRContext.connection, 'GetActivePlaylist failed', 'GetActivePlaylist', displayId);
    },
    [displayConnection, playlist]
  );

  return {
    hubstate: {
      connected: SignalRContext.connection?.state === HubConnectionState.Connected,
      connecting: SignalRContext.connection?.state === HubConnectionState.Connecting,
      disconnected: SignalRContext.connection?.state === HubConnectionState.Disconnected,
      disconnecting: SignalRContext.connection?.state === HubConnectionState.Disconnecting,
      reconnecting: SignalRContext.connection?.state === HubConnectionState.Reconnecting,
    },
    connection: displayConnection,
    playlist,
  };
}
